module.exports = __webpack_public_path__ + "img/fire-flame-simple.35188561.svg";